import { useEffect, EffectCallback } from 'react';

export const useMountEffect = (callback: EffectCallback) => useEffect(callback, []);
